<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row>
      <v-col cols="12" sm="4">
        <AutocompleteComp
          @change="getAllGradosAdmin(filtro.id_nivel)"
          v-model="filtro.id_nivel"
          textLabel="Nivel"
          :items="NivelesAdmin"
          item-value="id_nivel_adm_nivel"
          item-text="desc_nivel"
        />
      </v-col>

      <v-col cols="12" sm="4">
        <AutocompleteComp
          @change="getAllSeccionesGrados(filtro.id_grado)"
          v-model="filtro.id_grado"
          textLabel="Grado"
          :items="GradosAdmin"
          item-value="id"
          item-text="desc_grado"
        />
      </v-col>
      <v-col cols="12" sm="4">
        <AutocompleteComp
          @change="obtenerDatos(filtro.id_seccion)"
          v-model="filtro.id_seccion"
          textLabel="Sección"
          :items="SeccionGrado"
          item-value="id"
          item-text="nombre_seccion"
        />
      </v-col>
    </v-row>

    <div class="d-flex">
      <v-container>
        <v-row wrap>
          <v-col cols="12" v-if="cursosSecciones < 1">
            <v-card outlined>
              <v-card-text
                style="height: 500px"
                class="text-center d-flex justify-center align-center"
              >
                <span class="">
                  Aún no se ha agregado cursos a ésta sección
                </span>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col
            cols="12"
            sm="4"
            md="3"
            class="d-flex justify-center"
            v-for="item in cursosSecciones"
            :key="item.id"
          >
            <v-card
              width="240"
              elevation="7"
              :style="{ 'border-left': 'solid 5px' + item.color_curso }"
            >
              <v-list-item>
                <v-list-item-avatar
                  class="ml-0 mr-1"
                  size="50"
                  :color="item.color_curso"
                >
                  <v-icon dark>{{ item.icono_curso }}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0">
                  <span class="mb-1 font-weight-bold black--text">{{
                    item.desc_curso
                  }}</span>
                  <v-list-item-title class="caption"
                    >Área: {{ item.desc_area }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-card-text class="py-1" style="background-color: #eaeaea">
                <v-row dense>
                  <v-col cols="12" class="text-center" id="text">
                    {{ item.desc_nivel }} - {{ item.desc_grado }}
                  </v-col>
                  <v-col cols="12" class="text-center" id="text">
                    {{ item.nombre_pers ? item.nombre_pers : "Sin docente" }}
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-row dense>
                  <v-col cols="12" class="d-flex justify-center">
                    <ButtonComp
                      v-if="componenteEvento.editar_submodulo && item.docente"
                      @click="modalDocente('editar', item)"
                      textButton="Reasignar docente"
                      :disabled="!mostrarHorario"
                      iconBut="fas fa-plus"
                    />
                    <ButtonComp
                      v-if="componenteEvento.agregar_submodulo && !item.docente"
                      @click="modalDocente('agregar', item)"
                      textButton="Asignar docente"
                      :disabled="!mostrarHorario"
                      iconBut="fas fa-plus"
                    />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-end">
            <ButtonComp
              textButton="Ver docente asignado"
              @click="toggleDatosReferencia"
              :disabled="!mostrarHorario"
            ></ButtonComp>
          </v-col>
        </v-row>

        <v-container fluid class="d-flex justify-center">
          <ag-grid-vue
            v-if="mostrarHorario"
            class="ag-theme-balham"
            :columnDefs="columnDefs"
            :rowData="rowData"
            style="width: 1200px; height: 300px"
            @grid-ready="onGridReady"
          >
          </ag-grid-vue>

          <v-card
            v-else
            cols="12"
            md="6"
            class="d-flex justify-center"
            style="height: 100px; width: 1135px"
          >
            <span class="mt-2 pa-2 align-center justify-center">{{
              errorMensaje
            }}</span>
          </v-card>
        </v-container>
      </v-container>
    </div>

    <modalAsignarDocentes
      :diasHabiles="diasHabiles"
      :estadoComp="estadoComponente"
      :parametros="parametroComp"
      :docentesFiltrados="docentesFiltrados"
      :id_nivel="id_nivelParams"
      :rowData="rowData"
      :id_grado="id_grado"
      @close="estadoComponente = false"
      @reloadComp="reloadComp"
    ></modalAsignarDocentes>

    <component
      :is="compName"
      :estadoComp="estadoC"
      :parametros="parametroC"
      @close="estadoC = false"
    >
    </component>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import modalAsignarDocentes from "@/views/Horario/horariomanual/components/modalDocenteAsignar.vue";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import ButtonComp from "../../../components/ComponentsEst/TableButtonComp.vue";

export default {
  components: {
    modalAsignarDocentes,
    AutocompleteComp,
    ButtonComp,
    AgGridVue,
  },
  data() {
    return {
      paramComponente: { id_submodulo: 40, id_modulo: 6 },
      datoLogin: sessionStorage,
      test: false,
      columnDefs: null,
      rowData: null,
      filtro: {
        id_nivel: 0,
        id_grado: 0,
        id_seccion: 0,
      },
      NivelesAdmin: [],
      GradosAdmin: [],
      SeccionGrado: [],
      Horario: {},
      id_grado: null,
      id_nivelParams: null,
      mostrarMensaje: false,
      cursosSecciones: [],
      modal_Docentes: false,
      Profesores: [],
      search: "",
      estadoComponente: false,
      parametroComp: {},
      diasHabiles: null,
      gridApi: null,
      gridColumnApi: null,
      diasSemanas: [],
      nombresDiasHabiles: [],
      datos2: {},
      //variables para calcular hora del cuadro para renderizar
      hora: [],
      horasDisponibles: [], //
      duracion_hora_academica: "", //
      primeraHora: "", //
      horaEntrada: "", //
      horaSalida: "", //
      horaInicioRecreo: "", //
      duracionRecreo: "", //
      horaInicioRecreo2: "", //
      duracionRecreo2: "", //
      id_turno: null, //
      nombre_recreo: "", //
      nombre_recreo2: "", //
      duracionMinutos: "",
      horaBackCursos: [],
      horaBackProfesores: [],
      usarHoraBackProfesores: false,
      turnoSeccion: "",
      mostrarHorario: false,
      errorMensaje: "",
      id_colegio: sessionStorage.id_colegio,
      docentesFiltrados: [],

      // componente General
      compName: null,
      estadoC: true,
      parametroC: {},
    };
  },
  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  mounted() {
    this.getAllNivelesAdmin();
  },

  created() {
    this.actualizarParamentro();
    this.getDiasHabiles();
    this.getDiasDeLaSemana();
    this.cargarDatosYObtenerDiasHabiles();
    this.allDocentes();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-------traer mis niveles de administracion-------
    async getAllNivelesAdmin() {
      let params = {
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_colegio: this.datoLogin.id_colegio,
      };

      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/getNivel/",
          params
        );
        this.NivelesAdmin = response.data;
        console.log("nivelesAdmin", this.NivelesAdmin)
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //---------traer mis grados de administracion por nivel
    async getAllGradosAdmin(id_nivel) {
      this.cursosSecciones = [];
      let params = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_nivel,
      };

      try {
        let response = await axios.post(
          "/administrativo/grado/gradosNivelAdmin/",
          params
        );
        this.GradosAdmin = response.data;
        this.id_nivelParams = this.GradosAdmin[0].adm_nivel_id;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //----------secciones por grados ------------
    async getAllSeccionesGrados(id_grado) {
      this.id_grado = id_grado;

      this.cursosSecciones = [];
      let params = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_grado,
      };
      try {
        let response = await axios.post(
          "/administrativo/seccion/seccionGrado/",
          params
        );
        this.SeccionGrado = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async obtenerDatos(id) {
      this.cursosSecciones = [];
      this.horarioAcademico = [];
      this.rowData = [];
      try {
        await Promise.all([
          this.getAllCursosGrados(id),
          this.getSeccionTurnos(),
        ]);

        this.getHorarioAcademico();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    //---------obtener los cursos por secciones ---------
    async getAllCursosGrados(id) {
      this.cursosSecciones = [];

      this.mostrarMensaje = false;

      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_seccion: id,
      };
      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/cs/list/",
          params
        );
        this.cursosSecciones = response.data;

        this.datos2 = {
          id_nivel: this.SeccionGrado[0].id_nivel,
          id_grado: this.SeccionGrado[0].id_grado,
          id_colegio: this.datoLogin.id_colegio,
          id_ano_lectivo: this.datoLogin.id_ano_lectivo,
          id_seccion: this.filtro.id_seccion,
        };

        this.getHorarioPorSeccion();

        if (this.cursosSecciones.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    /************traer profesores del colegio ********/
    async allDocentes() {
      try {
        let response = await axios.get(
          `/horario/ConfiguracionDocente/${this.id_colegio}`
        );
        this.listDocente = response.data.payload;
      } catch (e) {
        this.setEnviarMens({
          tipo: "E",
          mensaje:
            e.response.data.message || "Error en la respuesta del servidor",
          tiempo: null,
        });
      }
    },

    combinarDocentes(listDocente, item) {
      console.log(item , "itemhorariosmanual");
      console.log(listDocente
        .filter(
          (docente) =>
            docente.id_nivel &&
            docente.id_nivel.some((nivel) => nivel === item.id_nivel_adm) &&
            docente.areas &&
            docente.areas.some((area) => area === item.id_area)
        ).map((docente) => ({
          ...docente,
          ...item,
          id_nivel_adm: item.id_nivel_adm,
          id_area: item.id_area,
          tipo_docente: docente.tipo_docente,
        })), "arraysdsoakin");
      
      
      return listDocente
        .filter(
          (docente) =>
            docente.id_nivel &&
            docente.id_nivel.some((nivel) => nivel === item.id_nivel_adm) &&
            docente.areas &&
            docente.areas.some((area) => area === item.id_area)
        )
        .map((docente) => ({
          ...docente,
          ...item,
          id_nivel_adm: item.id_nivel_adm,
          id_area: item.id_area,
          tipo_docente: docente.tipo_docente,
        }));
    },

    async modalDocente(evento, item) {
      console.log(this.listDocente, "thislistDocente");
      console.log(item, "itemmodaldocetne");
      
      
      this.estadoComponente = true;
      this.docentesFiltrados = this.combinarDocentes(this.listDocente, item);
      this.parametroComp = { evento, item };
    },

    // cerrar modal de ver docente perfil
    reloadComp() {
      this.getAllCursosGrados(this.filtro.id_seccion);
      this.setEnviarMens({
        tipo: "E",
        mensaje: `Recargar Componente`,
        tiempo: null,
      });
    },

    async getDiasHabiles() {
      let id_colegio = this.datoLogin.id_colegio;

      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${id_colegio}`
        );
        this.diasHabiles = response.data[0].dias_seleccionados;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async getDiasDeLaSemana() {
      try {
        let response = await axios.get("/mantenimiento/diasSemanas");
        this.diasSemanas = response.data;
        // aca estan todos los dias de lunes a domingo
      } catch (e) {
        // eslint-disable-next-line no-undef
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async cargarDatosYObtenerDiasHabiles() {
      try {
        await Promise.all([this.getDiasHabiles(), this.getDiasDeLaSemana()]);
        this.obtenerNombresDiasHabiles();
        this.actualizarColumnas();
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    },

    obtenerNombresDiasHabiles() {
      if (!this.diasHabiles || !this.diasSemanas) {
        return [];
      }

      this.nombresDiasHabiles = this.diasSemanas
        .filter((diaSemana) => this.diasHabiles.includes(diaSemana.id))
        .map((diaHabil) => diaHabil.nombre_dia);

      return this.nombresDiasHabiles;
    },

    // metodo para actualizar las columnas del horario

    actualizarColumnas() {
      if (!Array.isArray(this.nombresDiasHabiles)) {
        return;
      }

      // Columna fija para el horario
      const columnasDinamicas = [
        { field: "hora", headerName: "Hora", pinned: "left", width: 110 },
      ];

      // Y luego para los días hábiles:
      this.nombresDiasHabiles.forEach((dia) => {
        columnasDinamicas.push({
          headerName: dia,
          field: dia.toLowerCase(),
          width: 220,
        });
      });

      // Luego establece las columnDefs actualizadas y refresca el grid
      this.columnDefs = columnasDinamicas;
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },

    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    async getSeccionTurnos() {
      try {
        let response = await axios.get(
          `/administrativo/asignacionDocenteCurso/secciones/${this.filtro.id_seccion}`
        );
        this.turnoSeccion = response.data.id_turno;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    // esta peticion renderiz las filas por defecto cursos
    async getHorarioPorSeccion() {
      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/editedItem/seccionhorario/",
          this.datos2
        );
        this.horaBackCursos = response.data.cursos.map((item) => ({
          hora: item.hora,
          lunes: item.lunes || "",
          martes: item.martes || "",
          miércoles: item.miercoles || "",
          jueves: item.jueves || "",
          viernes: item.viernes || "",
          sábado: item.sabado || "",
          domingo: item.domingo || "",
        }));

        this.horaBackProfesores = response.data.profesores.map((item) => ({
          hora: item.hora,
          lunes: item.lunes || "",
          martes: item.martes || "",
          miércoles: item.miercoles || "",
          jueves: item.jueves || "",
          viernes: item.viernes || "",
          sábado: item.sabado || "",
          domingo: item.domingo || "",
        }));

        this.calcularHora();
      } catch (error) {
        this.estadoCalendar = false;
        this.errorMensaje = "No existe registro para este nivel y turno.";
      }
    },

    // Datos del Horario
    async getHorarioAcademico() {
      const id_colegio = this.datoLogin.id_colegio;

      try {
        let response = await axios.get(
          `/administrativo/horarioAcademico/${id_colegio}/${this.id_nivelParams}/${this.turnoSeccion}`
        );
        const horarioAcademico = response.data;

        if (horarioAcademico.length === 0) {
          this.errorMensaje =
            "No tienes un horario académico asignado para este turno y nivel.";
          this.mostrarHorario = false;
          // Puedes optar por retornar aquí si no deseas continuar con el resto del código
          // en caso de que no haya horario académico.
          return;
        }

        this.mostrarHorario = true;
        this.duracionMinutos = horarioAcademico[0].duracion_hora_academica;
        let formacion = horarioAcademico[0].hora_de_formacion;
        let minutos = parseInt(formacion.split(":")[1]);
        this.primeraHora = minutos;
        this.horaEntrada = horarioAcademico[0].hora_entrada;
        this.horaSalida = horarioAcademico[0].hora_salida;
        this.horaInicioRecreo = horarioAcademico[0].inicio_recreo1;
        let tiempoRecreo = horarioAcademico[0].tiempo_de_recreo;
        let minutosRecreo = parseInt(tiempoRecreo.split(":")[1]);
        this.duracionRecreo = minutosRecreo;
        this.horaInicioRecreo2 = horarioAcademico[0].inicio_recreo2;
        let tiempoRecreo2 = horarioAcademico[0].tiempo_de_recreo2;
        let minutosRecreo2 = parseInt(tiempoRecreo2.split(":")[1]);
        this.duracionRecreo2 = minutosRecreo2;
        this.id_turno = horarioAcademico[0].id_turno;
        this.nombre_recreo = horarioAcademico[0].titulo_recreo1;
        this.nombre_recreo2 = horarioAcademico[0].titulo_recreo2;
      } catch (error) {
        this.errorMensaje = "No existe registro para este nivel y turno.";
      }
    },

    calcularHora() {
      this.horasDisponibles = [];
      let horaInicio = this.horaEntrada.split(":").slice(0, 2).join(":");
      let horaFin = this.horaSalida.split(":").slice(0, 2).join(":");
      let horaInicioRecreo = this.horaInicioRecreo
        .split(":")
        .slice(0, 2)
        .join(":");
      let horaInicioRecreo2 = this.horaInicioRecreo2
        .split(":")
        .slice(0, 2)
        .join(":");

      // Añadir bloque de formación inicial
      if (this.primeraHora !== null && !isNaN(this.primeraHora)) {
        const horasPrimera = Math.floor(this.primeraHora / 60);
        const minutosPrimera = this.primeraHora % 60;
        let nuevaHoraInicio = new Date(
          2022,
          0,
          1,
          parseInt(horaInicio.split(":")[0]) + horasPrimera,
          parseInt(horaInicio.split(":")[1]) + minutosPrimera
        );
        let horas = nuevaHoraInicio.getHours().toString().padStart(2, "0");
        let minutos = nuevaHoraInicio.getMinutes().toString().padStart(2, "0");
        let horaFinFormacion = `${horas}:${minutos}`;

        if (horaInicio !== horaFinFormacion) {
          this.horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinFormacion}`,
            tipo: "Formación",
            horaInicio: horaInicio,
            horaFin: horaFinFormacion,
          });
          horaInicio = horaFinFormacion;
        }
      }

      let [horasDuracion, minutosDuracion] = this.duracionMinutos
        .split(":")
        .map(Number);
      let duracionTotalMinutos = horasDuracion * 60 + minutosDuracion;

      while (horaInicio < horaFin) {
        let [hora, minuto] = horaInicio.split(":").map(Number);
        let inicio = new Date(2022, 0, 1, hora, minuto);

        if (horaInicio === horaInicioRecreo) {
          let finRecreo = new Date(
            inicio.getTime() + this.duracionRecreo * 60000
          );
          let horasFinRecreo = finRecreo.getHours().toString().padStart(2, "0");
          let minutosFinRecreo = finRecreo
            .getMinutes()
            .toString()
            .padStart(2, "0");
          let horaFinRecreo = `${horasFinRecreo}:${minutosFinRecreo}`;

          this.horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo}`,
            tipo: `${this.nombre_recreo}`,
            horaInicio: horaInicio,
            horaFin: horaFinRecreo,
          });

          horaInicio = horaFinRecreo;
          inicio = finRecreo;
        }

        if (horaInicio === horaInicioRecreo2) {
          let finRecreo = new Date(
            inicio.getTime() + this.duracionRecreo2 * 60000
          );
          let horasFinRecreo = finRecreo.getHours().toString().padStart(2, "0");
          let minutosFinRecreo = finRecreo
            .getMinutes()
            .toString()
            .padStart(2, "0");
          let horaFinRecreo = `${horasFinRecreo}:${minutosFinRecreo}`;

          this.horasDisponibles.push({
            hora: `${horaInicio} - ${horaFinRecreo}`,
            tipo: `${this.nombre_recreo2}`,
            horaInicio: horaInicio,
            horaFin: horaFinRecreo,
          });

          horaInicio = horaFinRecreo;
          inicio = finRecreo;
        }

        let fin = new Date(inicio.getTime() + duracionTotalMinutos * 60000);
        let horasFin = fin.getHours().toString().padStart(2, "0");
        let minutosFin = fin.getMinutes().toString().padStart(2, "0");
        let nuevoInicio = `${horasFin}:${minutosFin}`;

        if (nuevoInicio > horaFin) break;

        this.horasDisponibles.push({
          hora: `${horaInicio} - ${nuevoInicio}`,
          tipo: "-",
          horaInicio,
          horaFin: nuevoInicio,
        });

        horaInicio = nuevoInicio;
      }

      let datosReferencia = this.usarHoraBackProfesores
        ? this.horaBackProfesores
        : this.horaBackCursos;
      this.newData = this.horasDisponibles
        .map((item) => ({
          hora: item.hora,
          lunes: item.tipo,
          martes: item.tipo,
          miércoles: item.tipo,
          jueves: item.tipo,
          viernes: item.tipo,
          sábado: item.tipo,
          domingo: item.tipo,
        }))
        .map((itemNewData) => {
          let horaBackItem = datosReferencia.find(
            (itemHoraBack) => itemHoraBack.hora === itemNewData.hora
          );
          if (horaBackItem) {
            Object.keys(horaBackItem).forEach((key) => {
              if (key !== "hora" && horaBackItem[key].trim() !== "") {
                itemNewData[key] = horaBackItem[key];
              }
            });
          }
          return itemNewData;
        });
      this.rowData = this.newData;
    },

    toggleDatosReferencia() {
      // Cambia el conjunto de datos de referencia cada vez que se presiona el botón
      this.usarHoraBackProfesores = !this.usarHoraBackProfesores;
      this.calcularHora();
    },
  },
};
</script>

<style scoped></style>
